import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("ccm_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  const d = localStorage.getItem("ccm_device");
  if (d) cfg.headers["X-Device-Token"] = d;
  return cfg;
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return detail.msg || String(detail);
}

export const errMsg = (e) => formatApiError(e?.response?.data?.detail);

export async function downloadFile(path, fallbackName) {
  const res = await api.get(path, { responseType: "blob" });
  const cd = res.headers["content-disposition"] || "";
  const name = (cd.match(/filename="?([^"]+)"?/) || [])[1] || fallbackName;
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = name;
  a.click();
  URL.revokeObjectURL(url);
}

export const COLORS = { blue: "#1074BA", orange: "#F58B23", cyan: "#03AB9E", grid: "rgba(255,255,255,0.08)" };
export const PALETTE = ["#1074BA", "#F58B23", "#03AB9E", "#7FB8E0", "#FBC17F", "#6FD6CD", "#64748B", "#0B4F80", "#C2410C", "#0E7490"];

export const fmt = (n, d = 0) =>
  n == null || isNaN(n) ? "—" : Number(n).toLocaleString("en-US", { maximumFractionDigits: d, minimumFractionDigits: d });
export const inr = (n) => "₹" + Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 0 });
export const uniq = (arr) => [...new Set(arr)].sort();
export const CURRENT_YEAR = 2026;

export const MODULES = [
  { id: "demand", label: "Market Demand & Forecast", path: "/dashboards/demand" },
  { id: "ccop", label: "Cash Cost of Production", path: "/dashboards/cash-cost" },
  { id: "prices", label: "Price Trends", path: "/dashboards/prices" },
  { id: "capacity", label: "Capacity Tracker", path: "/dashboards/capacity" },
  { id: "capex", label: "CAPEX Calculator", path: "/dashboards/capex" },
];
